module.exports = __webpack_public_path__ + "img/04_Datos - ICONO.3ce89ad7.png";